<template>
  <div class="notice">
    <div class="tab">
      <div class="item" :class="activeTab === index ? 'active' : ''" v-for="(item, index) in tabList" :key="index" @click="changeTab(item.type, index)">{{item.name}}</div>
    </div>
    <div class="notice-content">
      <div class="main" v-if="!loading&&noticeLists.length">
        <div class="item" v-for="(item, index) in noticeLists" :key="index">
          <div class="item-head">
            <div class="iconfont icon-laba-"></div>
            <div class="type">{{typeArr[item.type]}}</div>
            <div class="time">{{item.publish_time | formatTime}}</div>
          </div>
          <div class="item-content" @click="getMore(item)">
            <div class="title-wrap">
              <div class="top"  v-if="item.is_top === '1'">置顶</div>
              <div class="title">{{item.title}}</div>
            </div>
            <div class="content">{{item.content_filter}}</div>
            <div class="more">查看全部>></div>
          </div>
        </div>
        <div v-if="!loading&&hasMore" class="more-btn" @click="loadMore">加载更多</div>
      </div>
      <div class="tip-container">
        <tgoLoading v-if="loading" color="#D7B375" />
        <div class="wrapper" v-if="!loading&&!noticeLists.length">
          <span class="iconfont icon-empty"></span>
          <span class="warn-tip">暂无公告与动态</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tgoLoading from '@/components/loading'

import moment from 'moment'

import service from '@/service'
import data from '@/data'

export default {
  data () {
    return {
      scrollTop: 0,
      noticeLists: [],
      hasMore: false,
      activeTab: 0,
      typeArr: data.notice.typeMap, // tab 类型ID 内容映射
      tabList: data.notice.selectItems, // tab 数据
      params: {
        type: 0,
        page: 1,
        size: 10
      },
      loading: false
    }
  },
  components: {
    tgoLoading
  },
  created () {
    if (this.$route.query.type) {
      this.activeTab = Number(this.$route.query.type)
      this.params.type = Number(this.$route.query.type)
    }
    // if (this.$route.query.id) this.curId = Number(this.$route.query.id)

    this.setNoticeList()
    // window.addEventListener('scroll', () => {
    //   this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    // })
  },
  methods: {
    changeTab (type, index) {
      this.$router.push({ query: { type } }, () => {})
      this.activeTab = index
      this.params.type = type
      this.initNoticeList()
      this.setNoticeList()
    },
    initNoticeList () {
      this.params.page = 1
      this.noticeLists = []
    },
    setNoticeList () {
      if (this.loading) return
      this.loading = true

      service.getNoticeList(this.params).then(res => {
        this.loading = false

        let normalList = res.list
        normalList.forEach(item => {
          if (item.content_filter.length > 60) {
            item.content_filter = item.content_filter.slice(0, 60) + '...'
          }
        })
        this.hasMore = res.page.more
        this.noticeLists = this.noticeLists.concat(normalList)
      }).catch(() => { this.loading = false })
    },
    getMore (itemInfo) {
      if (itemInfo.link) {
        window.location.href = itemInfo.link
      } else {
        this.$router.push(`/notice/detail/${itemInfo.id}`)
      }
    },
    loadMore () {
      if (this.hasMore) {
        this.params.page = this.params.page + 1
        this.setNoticeList()
      }
    }
  },
  filters: {
    formatTime: function (publishTime) {
      return moment.unix(Number(publishTime)).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/bulma/app.sass';

.notice {
  // padding-top: 3rem;
  min-height: calc(100vh - 3rem);
  display: flex;
  flex-direction: column;
  .tab {
    flex-grow: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px;
    height: 44px;
    background: #fff;
    border-bottom: 1px solid rgba(154,154,154,.2);
    .item {
      position: relative;
      flex: none;
      // margin-right: 19px;
      font-size: 16px;
      color: #353535;
      &.active {
        font-weight: bold;
      }
      &:last-child {
        margin-right: 0;
      }
      &.active:before {
        content: '';
        position: absolute;
        width: 60%;
        height: 2px;
        background: $primary3;
        bottom: -5px;
        left: 50%;
        margin-left: -30%;
      }
    }
  }
  .notice-content {
    flex-grow: 1;
    background: #F5F5F5;
    height: 100%;
    position: relative;
  }
  .main {
    padding: 16px 0;
    .item {
      margin: 0 22px 14px;
      width: 88vw;
      border-radius: 4px;
      background: #fff;
      color: #353535;
      .item-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 12px 7px;
        font-size: 14px;
        border-bottom: 1px solid rgba(154,154,154,.1);
        .iconfont {
          padding-right: 6px;
          font-size: 12px;
          color: $primary3;
          transform: translateY(-1px);
        }
        .type {
          flex: 1;
        }
        .time {
          font-size: 12px;
          color: #9a9a9a;
        }
      }
      .item-content {
        padding: 12px 12px 16px;
        .title-wrap {
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          .top {
            flex: none;
            padding: 4px 5px 2px;
            margin-right: 6px;
            background: $primary3;
            border-radius: 2px;
            line-height: 1;
            font-size: 11px;
            font-weight: 500;
            color: #fff;
          }
          .title {
            font-weight: bold;
            font-size: 17px;
            line-height: 25px;
            // display: -webkit-box;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 1;
            @include limit-line-numbers(1)
          }
        }
        .content {
          line-height: 18px;
          font-size: 12px;
          color: #9a9a9a;
          margin-bottom: 5px;
        }
        .more {
          line-height: 1;
          text-align: right;
          font-size: 12px;
          color: #9a9a9a;
        }
      }
    }
  }

  // 暂无活动
  .tip-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: absolute;
    top: 43%;
    transform: translateY(-50%);
    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      .iconfont.icon-empty {
        font-size: 64px;
        color: rgba($primary3, 0.25);
      }
      .warn-tip {
        font-size: 16px;
        color: rgba(178, 178, 178, 1);
      }
    }
  }

  .more-btn {
    margin: 30px auto 15px;
    width: 40vw;
    height: 35px;
    border: 1px solid $primary3;
    border-radius: 3px;
    color: $primary3;
    font-size: 16px;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
  }
}
</style>
